import React from "react";
import { UserContextInterface } from "types/user";

export const UserContext = React.createContext<UserContextInterface>({
  currentUserId: null,
  setUser: (_userId: string | null) => {},
  logout: () => {},
});
